// extracted by mini-css-extract-plugin
export default {"Contacts":"Contacts_Contacts__WuC7p","address":"Contacts_address__yXnex","map":"Contacts_map__miB0M"};